import { connect } from 'react-redux';
import { databaseId as databaseIdSelector } from '@Selectors/StateParamsSelectors';
import ResultsFiltersButtons from './ResultsFiltersButtons';
import { limitTo, exclude, clear } from './ResultsFiltersButtonsActions';
import { disableButtons } from './ResultsFiltersButtonsSelectors';

function mapStateToProps(state) {
  return {
    databaseId: databaseIdSelector(state),
    disableButtons: disableButtons(state),
  };
}

const mapDispatchToProps = {
  limitTo,
  exclude,
  clear,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultsFiltersButtons);
